export const functions = [
  {
    id: 1,
    name: "PMI Medical",
    shortName: "Medical",
    description: "Having the best Quality of the medical items in the region that fulfills the need of The doctors adding value to the patients.",
    logo: "https://res.cloudinary.com/dvybb2xnc/image/upload/f_auto,q_auto/v1752659104/PMI_Blue_w7w1zn",
    officialLink: "https://medical.pmi-me.net/"
  },
  {
    id: 2,
    name: "IT Solutions",
    shortName: "IT",
    description: "Specialized division of PMI focused on developing smart, customized digital systems for businesses. We create websites, applications, and integrated platforms that enhance efficiency, connect departments, and support business growth through modern technology.",
    logo: "https://res.cloudinary.com/dvybb2xnc/image/upload/f_auto,q_auto/v1752659104/PMI_Purple_o6ml7r",
    officialLink: "https://it-solutions.pmi-me.net/"
  },
  {
    id: 3,
    name: "Health Care",
    shortName: "Health",
    description: "One-stop shop for all your healthcare needs. We offer a wide range of products to help you look and feel your best. Whether you're looking to enhance your skincare routine or improve your lifestyle, our site has everything you need to help you achieve your health goals.",
    logo: "https://res.cloudinary.com/dvybb2xnc/image/upload/f_auto,q_auto/v1752659104/PMI_HC_vyciee",
    officialLink: "#"
  },
  {
    id: 4,
    name: "Advertising and Publicity",
    shortName: "Ads",
    description: "Turn ideas into impact. Specializing in advertising, branding, website design, and full-scale digital services, we help businesses stand out in a fast-paced digital world. From powerful ad campaigns to custom-built websites, our team delivers creative solutions that drive real results.",
    logo: "https://res.cloudinary.com/dvybb2xnc/image/upload/f_auto,q_auto/v1752659104/PMI_Brown_ooq0sv",
    officialLink: "#"
  }
]; 